'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactGa = require('react-ga4');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const CATEGORY_USER = 'user'
// const CATEGORY_SEARCH = 'search'

var CATEGORY_FUND = 'fund';
var CATEGORY_FAMILY = 'family';
var CATEGORY_MORNINGSTAR = 'mstar';
var CATEGORY_FFF = 'gff';
var CATEGORY_WFF = 'gff';
var CATEGORY_TOOLKIT = 'toolkit';
var CATEGORY_DOWNLOAD = 'download';

function event(eventProps) {
  // console.log('event:',eventProps)
  if (_config2.default.gaKey) {
    _reactGa2.default.event(eventProps);
  }
}
function eventToMorningstar(investmentVehicleId) {
  return {
    category: CATEGORY_MORNINGSTAR,
    action: 'fund_to_morningstar',
    label: 'investmentVehicleId:' + investmentVehicleId
  };
}
function eventToFamily(familyName) {
  return {
    category: CATEGORY_FAMILY,
    action: 'front_to_family',
    label: 'family:' + familyName
  };
}
function eventLoadFund(fundId, investmentVehicleId) {
  return {
    category: CATEGORY_FUND,
    action: 'fund_searched',
    label: 'fundId:' + fundId + ',investmentId:' + investmentVehicleId
  };
}
function eventToFamilyPopup(familyName) {
  return {
    category: CATEGORY_FAMILY,
    action: 'popup_to_family',
    label: 'family:' + familyName
  };
}
function eventToFamilyTakeAction(familyName) {
  return {
    category: CATEGORY_FAMILY,
    action: 'family_take_action',
    label: 'family:' + familyName
  };
}
function eventToFFF(fundId, investmentVehicleId) {
  return {
    category: CATEGORY_FFF,
    action: 'to_fff',
    label: 'fundId:' + fundId + ',investmentId:' + investmentVehicleId
  };
}
function eventToWFF(fundId, investmentVehicleId) {
  return {
    category: CATEGORY_WFF,
    action: 'to_wff',
    label: 'fundId:' + fundId + ',investmentId:' + investmentVehicleId
  };
}
function eventToToolkit() {
  return {
    category: CATEGORY_TOOLKIT,
    action: 'to_toolkit'
  };
}
function eventDownloadChangelogExcel(datasetName) {
  return {
    category: CATEGORY_DOWNLOAD,
    action: 'dl_changelog_excel',
    label: 'dataset:' + datasetName
  };
}

exports.default = {
  event: event,
  eventToMorningstar: eventToMorningstar,
  eventToFamily: eventToFamily,
  eventToFamilyPopup: eventToFamilyPopup,
  eventLoadFund: eventLoadFund,
  eventToFamilyTakeAction: eventToFamilyTakeAction,
  eventToFFF: eventToFFF,
  eventToWFF: eventToWFF,
  eventToToolkit: eventToToolkit,
  eventDownloadChangelogExcel: eventDownloadChangelogExcel
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/analytics.js
// module id = 109
// module chunks = 0